var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2797 12.2207C13.5727 12.5137 13.5727 12.9888 13.2797 13.2818C13.1337 13.4278 12.9417 13.5017 12.7497 13.5017C12.5577 13.5017 12.3658 13.4288 12.2198 13.2818L6.74975 7.81173L1.27975 13.2818C1.13375 13.4278 0.941749 13.5017 0.749749 13.5017C0.557749 13.5017 0.36575 13.4288 0.21975 13.2818C-0.07325 12.9888 -0.07325 12.5137 0.21975 12.2207L5.68975 6.75076L0.21975 1.28079C-0.07325 0.987785 -0.07325 0.51275 0.21975 0.21975C0.51275 -0.07325 0.987755 -0.07325 1.28075 0.21975L6.75076 5.68978L12.2207 0.21975C12.5137 -0.07325 12.9887 -0.07325 13.2817 0.21975C13.5747 0.51275 13.5747 0.987785 13.2817 1.28079L7.81175 6.75076L13.2797 12.2207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/close-dropdown.53049c991ec64699710469ce41aeb530.svg";
export { ForwardRef as ReactComponent };